import I from '../types.ts';

const textMessageHandler: I['textMessageHandler'] = function ({ value }) {
    return new Promise((resolve) => {
        this.setState({ textMessage: value as string }, resolve);
    });
};

export default textMessageHandler;
